import merge from 'deepmerge';

// TODO: Move URLs here as they are verified as working for multi-brand
export const createCommonSiteUrls = <T extends string>(siteUrl: T) =>
  ({
    url: `${siteUrl}/`,
    legal: {
      privacy: `${siteUrl}/privacy`,
      telehealthConsent: `${siteUrl}/telehealth-consent`,
      terms: `${siteUrl}/terms`,
    },
  }) as const;

export const createCurologySiteUrls = <T extends string>(siteUrl: T) =>
  merge(createCommonSiteUrls(siteUrl), {
    checkout: `${siteUrl}/checkout`,
    legal: {
      doNotSell: `${siteUrl}/donotsell`,
    },
    shop: `${siteUrl}/shop`,
  } as const);

export const createAgencySiteUrls = createCommonSiteUrls;
